(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bch-wallerwissen"]) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-journal-labels]').textContent);
    const grid = root.querySelector('[data-article-grid]');
    const title = root.querySelector('[data-archive-title]');
    const status = root.querySelector('[data-status]');
    const pagination = root.querySelector('[data-pagination]');
    const empty = root.querySelector('[data-empty]');
    const links = [...root.querySelectorAll('[data-category]')];
    const valid = new Set(links.map(link => link.dataset.category));
    const seen = new Set([...grid.children].map(card => card.dataset.articleId));
    let next = root.dataset.next;
    let request;
    let revision = 0;
    const loadArchive = () => {
      if (request) return request;
      request = (async () => {
        while (next) {
          const url = new URL(next, location.origin);
          const current = new URL(location.href);
          for (const name of ['preview_theme_id', 'preview_key']) {
            if (current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
          }
          url.searchParams.set('section_id', root.dataset.section);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Archive unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const archive = doc.querySelector('[data-bch-journal]');
          if (!archive) throw new Error('Archive missing');
          archive.querySelectorAll('[data-article-id]').forEach(card => {
            if (!seen.has(card.dataset.articleId)) { seen.add(card.dataset.articleId); grid.append(card); }
          });
          next = archive.dataset.next;
        }
      })().catch(error => { request = null; throw error; });
      return request;
    };
    const apply = async () => {
      const key = location.hash.slice(1);
      const archive = root.querySelector('[data-category-results]');
      if (!valid.has(key) || key === 'kategorien') {
        ++revision;
        archive.hidden = true;
        links.forEach(link => link.removeAttribute('aria-current'));
        root.removeAttribute('aria-busy');
        return;
      }
      archive.hidden = false;
      const selected = key;
      const currentRevision = ++revision;
      const active = links.find(link => link.dataset.category === selected);
      links.forEach(link => {
        if (link.dataset.category === selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      title.textContent = active.querySelector('strong').textContent;
      status.textContent = labels.loading;
      root.setAttribute('aria-busy', 'true');
      try {
        await loadArchive();
        if (currentRevision !== revision) return;
        let count = 0;
        [...grid.children].forEach(card => {
          const tags = card.dataset.categories.split(/\s+/);
          const match = tags.includes(selected) || (selected === 'tackle-ausruestung' && tags.includes('tackle-ausrustung')) || (selected === 'montagen-rigs' && tags.includes('montagen'));
          card.hidden = !match;
          if (match) count++;
        });
        empty.hidden = count > 0;
        pagination.hidden = true;
        status.textContent = labels.results.replace('[count]', count);
      } catch (error) {
        if (currentRevision !== revision) return;
        status.textContent = labels.error;
        empty.hidden = true;
        pagination.hidden = false;
        [...grid.children].forEach(card => { card.hidden = true; });
      } finally { if (currentRevision === revision) root.removeAttribute('aria-busy'); }
    };
    window.addEventListener('hashchange', apply);
    window.addEventListener('popstate', apply);
    links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      apply();
      root.querySelector(link.dataset.category === 'kategorien' ? '.bch-journal__categories' : '.bch-journal__archive').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    }));
    apply();
  };
  const boot = () => document.querySelectorAll('[data-bch-journal]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
